import { Link } from "react-router-dom";
import teamOfficeImage from "../../assets/HomeImages/team-office.webp";
import Eyebrow from "../common/Eyebrow";
import Reveal from "../common/Reveal";

const HomeTeam = () => {
  return (
    <section className="bg-slate-50 px-6 py-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal direction="left">
            <div className="group overflow-hidden rounded-3xl border border-slate-200 bg-white p-3 transition duration-300 hover:border-[rgba(var(--website-secondary-rgb),0.6)] hover:shadow-lg">
              <div className="overflow-hidden rounded-2xl">
                <img
                  src={teamOfficeImage}
                  alt="The QuantaRock team discussing infrastructure plans in our office"
                  className="h-auto w-full rounded-2xl transition duration-300 group-hover:scale-105"
                  loading="lazy"
                  width={1600}
                  height={894}
                />
              </div>
            </div>
          </Reveal>

          <Reveal direction="right">
            <div>
              <Eyebrow>People behind the platform</Eyebrow>
              <h2 className="mt-3 text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">
                Team and Expertise
              </h2>
              <p className="mt-5 leading-relaxed text-slate-600">
                Our team brings hands-on expertise across IT hardware, data
                center operations, procurement, and customer support, backed by
                certifications including ISO 27001, ISO 9001, and specialist
                training in network security and information security
                management.
              </p>
              <p className="mt-5 text-base leading-relaxed text-slate-600">
                We invest in continuous training to stay current with evolving
                infrastructure, security, and compliance standards.
              </p>
              <Link
                to="/company/about-us"
                className="mt-7 inline-flex rounded-full bg-[var(--website-primary-color)] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[var(--primary-hover)]"
              >
                Meet the full team
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default HomeTeam;
